import { useHttp } from '../http'

export const useWorkoutExecutionHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`workout-executions/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`workout-executions`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`workout-executions/${id}`)
    }

    const _export = <T>(payload: any): Promise<T> => {
        return useHttp().get(`workout-executions/export`, payload, { responseType: 'blob' })
    }

    const _putData = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`workout-executions/${id}/data`, payload)
    }

    return {
        find,
        get,
        del,
        _export,
        _putData,
    }
}
